import { colors, FelaCSS, spacing } from '@bridebook/ui';
import { IThemeProperties } from '@bridebook/web/lib/wedding-website/utils';

interface IStyles {
  wrapper: FelaCSS;
  container: FelaCSS;
  title: FelaCSS;
  divider: FelaCSS;
}

const componentStyles: (themeProperties: IThemeProperties) => IStyles = (themeProperties) => ({
  wrapper: {
    display: 'none',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    backgroundColor: colors.white,
    color: colors.space,
    fontSize: 16,
    fontFamily: themeProperties.primaryFontStyle.fontFamily,
    fontWeight: themeProperties.primaryFontStyle.fontWeight,
    paddingVertical: spacing[4],
    minWidthMobileLg: {
      display: 'flex',
    },
  },
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing[6],
  },
  divider: {
    width: 1,
    height: 16,
    backgroundColor: colors.space15,
  },
});

export default componentStyles;
